import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=7da24a9d&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "not-found.vue"
export default component.exports